import * as API from "@/api/index.js"

export default {
  name: "user-group-transfer",
  components: {

  },

  model:{
    prop:"selection",
    event:"change",
  },

  props: {
    selection: {

    },

    user_group_url: {
        type: String,
        default: "/omnis/system/user_group_role",   // 组源数据接口路由
    },

    user_group_param:{
      type: Object,
      default: function () {
        return {}    // 组源数据接口参数
      }
    },

    header_check_disabled:{
      type: Boolean,
      default: false,   // 头部全选 复选框禁用
    },

  },

  data() {

    return {
      user_group_selected: [],   // 选择的数据
      filterMethod(query, item) {
           return (item.spy.indexOf(query) > -1) ||( item.user_group_name &&　item.user_group_name.indexOf(query) > -1) ;
      },
      group_loading: false,
      user_group_all: [],   // 组数据
    }
  },
  mounted() {

    this.get_all_group();

  },

  computed: {},

  watch: {

    selection: {
      handler(data){
        this.user_group_selected = data;
      },
      deep:true,
    },

    user_group_selected: {
      handler(data){
        let data_details = this.user_group_all.filter(item => data.indexOf(item.user_group_id) > -1)
        this.$emit("change", data);
        this.$emit("data_change", data_details);
      },
      deep:true,
    },

  },

  methods: {
    get_all_group(){
      if (this.user_group_all.length === 0){
        this.all_group_req()
      }
    },

    async all_group_req() {
        this.group_loading = true
        const response = await API.GET(this.user_group_url, this.user_group_param)
        this.group_loading = false
        let data = response.data
        if (data.success) {
          this.user_group_all = data.data
          this.user_group_selected = this.selection;

        }
      },

  },

}



// WEBPACK FOOTER //
// ./src/omnis-business/user-group-transfer/user-group-transfer.js